document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.custom-support-content').forEach(function (section) {
    var toggles = section.querySelectorAll('.csc-accordion-toggle');

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var item = toggle.closest('.csc-accordion-item');
        var panel = item.querySelector('.csc-accordion-panel');
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';

        // Close all other accordion items in this section (optional: comment out for multi-open)
        toggles.forEach(function (otherToggle) {
          if (otherToggle !== toggle) {
            otherToggle.setAttribute('aria-expanded', 'false');
            var otherPanel = otherToggle.closest('.csc-accordion-item').querySelector('.csc-accordion-panel');
            otherPanel.style.maxHeight = null;
          }
        });

        if (isOpen) {
          toggle.setAttribute('aria-expanded', 'false');
          panel.style.maxHeight = null;
        } else {
          toggle.setAttribute('aria-expanded', 'true');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  });
});
